import React, { Component } from 'react';
import  TopMenu   from './TopMenu'

export class Layout extends Component {
  static displayName = Layout.name;

  render () {
    return (
      <>
      <TopMenu />
      <div>
          {this.props.children}
      </div>
      </>
    );
  }
}
